const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/OfficeModalClose.css");

module.exports = createReactClass({
	displayName: "OfficeModalClose",

	propTypes: {
		useFallback: PT.bool,
		handleClose: PT.func.isRequired,
		closeColor: PT.oneOf(["white", "gray"]),
		closeClass: PT.string,
		hideIcons: PT.bool,
	},

	render: function() {
		let closeClass = this.props.useFallback
			? styles.closeFallback
			: styles.close;
		if (this.props.closeClass) closeClass = this.props.closeClass;
		if (this.props.hideIcons) {
			return <div className={closeClass} onClick={this.props.handleClose} />;
		}
		const color = this.props.closeColor || "gray";
		return (
			<div
				className={styles.main + " " + closeClass}
				onClick={this.props.handleClose}
			>
				<div className={styles[color]} />
				<div className={styles[color + "Hover"]} />
			</div>
		);
	},
});
